var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDoorKnock = function SvgDoorKnock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.44 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".door-knock_svg__abc{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "door-knock_svg__f4bc8e86-6e81-4ac4-aac5-dcb0947d50e4",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "door-knock_svg__ff842216-6cc6-4a34-8a2d-d638aca36892",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.94 3.5v-2a1 1 0 0 1 1-1h13a1 1 0 0 1 1 1v21a1 1 0 0 1-1 1h-13a1 1 0 0 1-1-1v-3",
    className: "door-knock_svg__abc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "door-knock_svg__a68a2b75-2f5a-4a70-81e1-949a9aabdc70",
    "data-name": "Interface-Essential Select hand-drag-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "door-knock_svg__b587a94d-33f7-417e-8892-bed2c16fa11e",
    "data-name": "Group 705"
  }, /*#__PURE__*/React.createElement("g", {
    id: "door-knock_svg__a6d416c1-bd9b-489a-b92b-311241e00dfb",
    "data-name": "hand-drag-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "door-knock_svg__b8137ed0-b331-409d-9e40-1426e1a17ce0",
    d: "M3 10.49v-3a1.29 1.29 0 0 1 2.57 0v.86",
    className: "door-knock_svg__abc",
    "data-name": "Shape 3356"
  }), /*#__PURE__*/React.createElement("path", {
    id: "door-knock_svg__b84b153e-d689-46e4-9473-f419d41d3e17",
    d: "M8.14 8.35v-.86a1.29 1.29 0 0 1 2.57 0v.86",
    className: "door-knock_svg__abc",
    "data-name": "Shape 3357"
  }), /*#__PURE__*/React.createElement("path", {
    id: "door-knock_svg__ae342224-22e3-49ec-a501-3da4fe70651c",
    d: "M8.14 7.49v-.85h0a1.29 1.29 0 1 0-2.57 0h0v.85",
    className: "door-knock_svg__abc",
    "data-name": "Shape 3358"
  }), /*#__PURE__*/React.createElement("path", {
    id: "door-knock_svg__b1d3c69f-4f44-41d2-a8c8-69e20f418400",
    d: "M10.71 9.64V8.35a1.29 1.29 0 0 1 2.58 0v4.72A4.29 4.29 0 0 1 9 17.35H6.14c-4.85 0-5.71-4.28-5.71-6v-.86c0-.83.43-1.71 1.28-1.71H3",
    className: "door-knock_svg__abc",
    "data-name": "Shape 3359"
  })))), /*#__PURE__*/React.createElement("circle", {
    cx: 18.92,
    cy: 12.4,
    r: 1.5,
    className: "door-knock_svg__abc"
  })))));
};
export default SvgDoorKnock;